export default "__VITE_ASSET__02311bec__"